var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  className: "svg-safari-fix",
  viewBox: "0 0 24 24",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.76 11.3202L14.65 5.27021C14.26 4.88021 13.63 4.89021 13.24 5.27021C12.85 5.66021 12.86 6.30021 13.24 6.68021L17.63 11.0202H4C3.45 11.0202 3 11.4702 3 12.0202C3 12.5702 3.45 13.0202 4 13.0202H17.6L13.28 17.2502C12.89 17.6402 12.88 18.2702 13.26 18.6602C13.46 18.8602 13.72 18.9602 13.97 18.9602C14.22 18.9602 14.47 18.8702 14.67 18.6702L20.75 12.7202C20.94 12.5302 21.05 12.2802 21.05 12.0102C21.05 11.7402 20.94 11.4902 20.75 11.3002L20.76 11.3202Z",
  fill: "inherit"
})));
export default SvgArrowRight;